import {loadState} from '../localStorage'
import {actionCreatorObj} from '../functions/redux'

const MAIN = 'user/'

const EDIT_USER = MAIN+'EDIT'
const LOAD_PERMISSIONS = MAIN+'PERMISSIONS'

export const editUser=actionCreatorObj(EDIT_USER)
export const loadPermissions=actionCreatorObj(LOAD_PERMISSIONS)

export const initialState = {
  auth:loadState(),
  permissions: new Set(),
}
export default function reqUsers(state = initialState, action){
  switch (action.type){
    case EDIT_USER : return {...state, auth:{...state.auth,...action.payload}}
    case LOAD_PERMISSIONS: return loadPermissions1(state, action.payload)
    default : return state;
  }
}
function loadPermissions1(state, payload){
  const incomingPermissions = payload?.permissions || [];
  return ({
    ...state,
    permissions: incomingPermissions, 
    permissionsSet: new Set(incomingPermissions)
  })
}